import { useEffect } from 'react'
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom'
import Home from './pages/Home';
import Shops from './pages/Products';
import Card from './pages/Card';
import Details from './pages/Details';
import Shipping from './pages/Shipping';
import { useDispatch } from 'react-redux';
import { get_category } from './store/reducers/homeReducer'
import CategoryShops from './pages/CategoryShop';
import SearchProducts from './pages/SearchProducts';
import Payment from './pages/Payment';
import Dashboard from './pages/Dashboard';
import Sellers from './pages/Sellers';
import SellerStore from './pages/SellerStore';
import ProtectUser from './utils/ProtectUser';
import Index from './components/dashboard/Index';
import Orders from './components/dashboard/Orders';
import Wishlist from './components/dashboard/Wishlist';
import ChangePassword from './components/dashboard/ChangePassword';
import Order from './components/dashboard/Order';
import Chat from './components/dashboard/Chat';
import ConfirmOrder from './pages/ConfirmOrder';
import AuthForm from './pages/AuthForm/AuthForm';
import BottomNav from './components/BottomNav';
import Categories from './pages/Categories';
// import AnimatedCursor from "react-animated-cursor"
import Contact from './pages/Contact';
import NotFound from './pages/components/NotFound'
// import AboutUs from './pages/About';
// import TryOnHijab from "./pages/TryOnHijab"
// import Detect from './pages/Detect'
// import Customize from './pages/Customize';
import Success from './pages/Success';

import { HelmetProvider } from 'react-helmet-async';

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(get_category())
  }, [dispatch])
  return (
    <HelmetProvider>
    <BrowserRouter>
      {/* <AnimatedCursor
        innerSize={8}
        outerSize={35}
        innerScale={1}
        outerScale={2}
        outerAlpha={0}
        hasBlendMode={true}
        innerStyle={{
          backgroundColor: '#292929'
        }}
        outerStyle={{
          border: '2px solid #292929'
        }}
      /> */}
       <ScrollToTop />
      <Routes>
        <Route path='/register' element={<AuthForm />} />
        <Route path='/login' element={<AuthForm />} />
        <Route path='/' element={<Home />} />
        <Route path='/products' element={<Shops />} />
        <Route path='/sellers' element={<Sellers />} />
        <Route path='/seller/:sellerId' element={<SellerStore />} />
        {/* <Route path='/about' element={<AboutUs />} /> */}
        <Route path='/contact' element={<Contact />} />
        <Route path='/products?' element={<CategoryShops />} />
        <Route path='/products/search?' element={<SearchProducts />} />
        <Route path='/card' element={<Card />} />
        <Route path='/order/confirm?' element={<ConfirmOrder />} />
        <Route path='/shipping' element={<Shipping />} />
        <Route path='/payment' element={<Payment />} />
        <Route path='/product/details/:slug' element={<Details />} />
        <Route path='/categories' element={<Categories />} />
        {/* <Route path='/product/details/TryOnHijab' element={<TryOnHijab />} />
        <Route path='/product/details/Detect' element={<Detect />} />
        <Route path='/product/details/Customize/:slug' element={<Customize />} />
        <Route path='/product/details/Customize' element={<Customize />} /> */}
        <Route path='/success' element={<Success />} />
        <Route path="*" element={<NotFound/>} />

        <Route path='/dashboard' element={<ProtectUser />}>
          <Route path='' element={<Dashboard />}>
            <Route path='' element={<Index />} />
            <Route path='my-orders' element={<Orders />} />
            <Route path='my-wishlist' element={<Wishlist />} />
            <Route path='order/details/:orderId' element={<Order />} />
            <Route path='chage-password' element={<ChangePassword />} />
            <Route path='chat' element={<Chat />} />
            <Route path='chat/:sellerId' element={<Chat />} />
          </Route>
        </Route>

      </Routes>
      <BottomNav/>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
